export const API_URL                = "https://test-soulclick.soulclick.io/";
export const ACCESS_STORAGE_PREFIX  = 'SoulclickPaymentDashboard';
export const INVOICE_PAYMENT_METHOD = 'QR-Rechnung';
export const CONTACTS_PRIVATE       = 'Privat';
export const CONTACTS_CORPORATE     = 'Geschäft';
export const BASE_CURRENCY          = 'CHF';